import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-slider--right",
  "use": "icon-slider--right-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-slider--right\"><path d=\"m3.172 8.464 10.11-.005L8.69 3.865l.77-.77L15.364 9l-5.905 5.905-.77-.77 4.594-4.594-10.11-.005V8.464Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol